import React, { useEffect, useState } from 'react';
import {
  DivFlexCenter,
  Container,
  ImageHeader,
  DivTextAlignCenter,
  BackButton,
  BackDiv,
  DivQRCode,
  TextLabel,
  IconRight,
  CopyPaste,
  CopyPasteDiv
} from '../../styles/styles';
import Logo from '../../assets/seclogoanimado.gif';
import moment from 'moment';
import PoweredBy from '../../assets/powered by@2x.png';
import QRCode from 'react-qr-code';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { useAlert } from 'react-alert';
import { IAvulso, ICobranca, IParametros } from '../../types/TicketInterface';
import PixPdvService from '../../services/PixPdvService';
import TicketService from '../../services/TicketService';

const PayPix: React.FC = () => {
  const alert = useAlert();
  const [pixKey, setPixKey] = useState<string>('');

  const avulso = JSON.parse(localStorage.getItem('ticket')!) as IAvulso;
  const cobranca = JSON.parse(localStorage.getItem('cobranca')!) as ICobranca;

  const intervaloMs = 5000;

  useEffect(() => {
    let tempoCorrido = 0;
    let idQrCode = '';

    localStorage.setItem('bandeira', 'PIX');

    const fetchData = async () => {
      const request = {
          valor: cobranca.douValorCobrado,
          codigoTicket: avulso.strcodigo,
          mensagem: ''
      };

      try {
        const qrcodeResponse = await PixPdvService.generateQrCode(
          JSON.stringify(request), 
          avulso.regestacionamento.idtblestacionamento);

        if (!qrcodeResponse.data) {
            alert.error('Falha desconhecida ao gerar cobrança pix! Tente novamente ou contate a administração.');
            return;
        }

        idQrCode = qrcodeResponse.data.qrCodeId;
        setPixKey(qrcodeResponse.data.chave);
      } catch (error: any) {
        if (error.response) {
          alert.error(error.response.data || "Erro desconhecido ao gerar cobrança. Tente novamente ou contate a administração");
        } else {
          alert.error("Ocorreu um erro inesperado ao processar a solicitação. Tente novamente ou contate a administração");
        }
      }
    };

    fetchData();
    
    const intervalId = setInterval(async () => {
      try {
        tempoCorrido += intervaloMs;
        
        if (!idQrCode) {
          return;
        }

        const qrcodeStatusResponse = await PixPdvService.getQrCodeStatus(idQrCode);

        if (!qrcodeStatusResponse.data) {
          clearInterval(intervalId);
          alert.error('Falha desconhecida ao consultar o status do qrcode! Tente Novamente ou contate a administração.');
          return;
        }

        if (qrcodeStatusResponse.data.statusQrCode === 'EXPIRADO' ) {
          clearInterval(intervalId);
          goToTimeoutPage();
          return;
        }

        if (qrcodeStatusResponse.data.statusQrCode === 'APROVADO') {
          clearInterval(intervalId);
          localStorage.setItem('CPF/CNPJ', qrcodeStatusResponse.data.documentoPagador);
          await confirmPayment();
          return;
        }
      } catch (error: any) {
        console.log(error);
        clearInterval(intervalId);

        if (error.response) {
          alert.error(error.response.data || "Erro desconhecido consultar status da cobrança. Tente novamente ou contate a administração");
        } else {
          alert.error("Ocorreu um erro inesperado ao consultar a solicitação. Tente novamente ou contate a administração");
        }
      }
    }, intervaloMs);
    

    return () => clearInterval(intervalId);
  }, []);

  const confirmPayment = async () => {
    try {
      const response = await TicketService.postConfirmaPagamento();
      localStorage.setItem('confirmaPagamento', JSON.stringify(response.config.data));
      localStorage.setItem('dataPagamento', moment().format('DD/MM/YYYY HH:mm:ss'));
      localStorage.setItem('respostaPagamento', JSON.stringify(response.data));

      setTimeout(() => goToReceiptPage(), 1000);
    } catch (error: any) {
      console.log(error.response);

      if (error.response) {
        alert.error(error.response.data || 'Falha desconhecida ao confirmar o pagamento do avulso! Tente novamente ou contate a administração.');
      } else {
        alert.error('Occoreu um erro inesperado ao confirmar a operação. Tente novamente ou contate a administração');
      }
    }
  }

  const goToLastPage = () => window.history.back();
  
  const goToTimeoutPage = () => window.location.href = 'TimeoutPix';

  const goToReceiptPage = () => window.location.href = 'Receipt';

  const copyToClipboard = () => {
    if (pixKey) {
      navigator.clipboard.writeText(pixKey).then(() => {
        alert.success('Copiado para a área de transferência');
      });
    }
  };

  return (
    <>
      <BackDiv className="mt-2">
        <BackButton type="button" onClick={goToLastPage} className="btn btn-icon-only">
          <span style={{ color: '#fff' }}>
            <FontAwesomeIcon size="2x" icon={faChevronLeft} />
          </span>
        </BackButton>
      </BackDiv>

      <DivFlexCenter>
        <Container className="mt-2 mb-2">
          <DivTextAlignCenter>
            <ImageHeader src={Logo} style={{ width: '150px', height: '150px' }} alt="Logo" />
            <hr />

            <TextLabel>Leia o QR Code</TextLabel>

            <DivQRCode className="mt-2 mb-2">
              {pixKey && <QRCode value={pixKey} level="L" size={256} />}
            </DivQRCode>

            <TextLabel>ou</TextLabel>
            <br />
            <TextLabel>copie e cole a chave do Pix</TextLabel>

            <CopyPasteDiv>
              <CopyPaste title="Clique para copiar" className="form-control" onClick={copyToClipboard}>
                {pixKey || 'Carregando...'}
              </CopyPaste>
            </CopyPasteDiv>

            <IconRight style={{ color: '#CE6B00' }} onClick={copyToClipboard}>
              <FontAwesomeIcon icon={faCopy} />
            </IconRight>

            <hr />
            <img src={PoweredBy} alt="Powered By" />
          </DivTextAlignCenter>
        </Container>
      </DivFlexCenter>
    </>
  );
};

export default PayPix;
